/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_Kb4Inputs */

const en_mk_cmp_clickup_kb4 = /** @type {(inputs: Mk_Cmp_Clickup_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat per division with agents you can mention in a thread.`)
};

const id_mk_cmp_clickup_kb4 = /** @type {(inputs: Mk_Cmp_Clickup_Kb4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim per divisi dengan agen yang bisa disebut di thread.`)
};

/**
* | output |
* | --- |
* | "Team chat per division with agents you can mention in a thread." |
*
* @param {Mk_Cmp_Clickup_Kb4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_kb4 = /** @type {((inputs?: Mk_Cmp_Clickup_Kb4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_Kb4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_kb4(inputs)
	return en_mk_cmp_clickup_kb4(inputs)
});